// extracted by mini-css-extract-plugin
export default {"getintouch":"getintouch_getintouch__fR6CI","brand-contact":"getintouch_brand-contact__PO-45","images":"getintouch_images__gXQAU"};